import { Tooltip } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import CollectionAddAndEdit from '@components/CollectionAddAndEdit';
import ListViewType from '@components/ListViewType';
import Permission from '@components/Permission';
import { toastError } from '@components/Toast';

import Chip from '@features/filter/Chip';
import AsyncSearch from '@features/filter/Common/AsyncSearch';
import Search from '@features/filter/Common/Search';
import Sort from '@features/filter/Common/Sort';

import {
	clearGlobalFilterWithSelectedFields,
	handleFilter,
	storeItemInGlobalFilter
} from '@store/actions/FilterAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { onTogglePrice } from '@store/actions/SystemPreferenceAction';

import { setSystemUserPreferences } from '@services/commonService';

import { getUserInfo, onGetSystemPreferences } from '@utils/Util';

import { PERMISSIONS } from '@/constants/constant';
import { ICONS } from '@/constants/icons';

const FilterTopHeader = ({
	setShowFilter,
	showFilter,
	searchBoxPlaceHolder,
	addNewTitle,
	showSorting = true,
	totalElements,
	callBack,
	onSetDefaultView,
	onClickTab,
	viewType,
	isFromNitexStudio,
	requestFrom = null,
	isShowAddButton,
	pathName,
	setIsShowFavouriteFolderPopup,
	isShowArchiveTab = true,
	isShowDesignersTechpack = false,
	setIsShowDesignersTechpack
}) => {
	const [isAddNew, setIsAddNew] = useState(false);
	const [systemPreference, setSystemPreference] = useState(null);
	const filterResponse = useSelector((store) => store.filterResponseStore);
	const filterFields = useSelector((store) => store.filterFieldStore);
	const [selectedTab, setSelectedTab] = useState('');
	const dispatch = useDispatch();
	const systemPreferenceResponse = useSelector((store) => store.systemPreferenceReducer);
	const [isShowPrice, setIsShowPrice] = useState(systemPreferenceResponse);
	const [searchParams] = useSearchParams();

	useEffect(() => {
		const data = onGetSystemPreferences();
		setIsShowPrice(data?.isShowPrice);
		setSystemPreference({ ...data });
	}, [systemPreferenceResponse]);

	const onSetPriceType = async (value) => {
		try {
			dispatch(openLoader());
			let body = {
				...systemPreference,
				isShowPrice: value
			};
			await setSystemUserPreferences(body);
			dispatch(closeLoader());
			dispatch(onTogglePrice(value));
		} catch (error) {
			dispatch(closeLoader());
			toastError(error.message);
		}
	};

	const onPriceToggleClick = (value) => {
		setIsShowPrice(value);
		onSetPriceType(value);
	};

	const toggleFilter = () => {
		setShowFilter(!showFilter);
	};

	useEffect(() => {
		let activeTab = filterFields?.availabilityStatusList || [];
		let currentTabOfGlobal = activeTab.find((item) => item.type === 'SELECT');
		setSelectedTab(currentTabOfGlobal?.key);
	}, [filterFields]);

	const fetchCollectionList = () => {
		let queryParams = '?&sort=id,desc&page=0&size=12';
		dispatch(handleFilter('getCollectionList', queryParams, false));
		setIsAddNew(false);
	};

	const onSetStore = (type) => {
		let data = {};
		data = {
			key: type.name,
			name: 'availabilityStatusList',
			value: type.constant,
			type: 'SELECT',
			isHideChip: true
		};
		dispatch(storeItemInGlobalFilter(data));
	};

	const onClickDesignTab = async (type) => {
		setSelectedTab(type.name);
		onSetStore(type);
		setIsShowDesignersTechpack && setIsShowDesignersTechpack(false);
		if (type.constant === 'SUGGESTED') {
			await onSetViewSetting('COLLECTION_TAB');
			onClickTab('SUGGESTED_FOR_BUYER');
		}
	};

	const TAB_FOR_ALL = [
		{ name: 'All', viewName: 'All', constant: 'ALL' },
		{ name: 'Sold', viewName: 'Sold', constant: 'SOLD' },
		{ name: 'archived', viewName: 'Archived', constant: 'ARCHIVED' }
	];

	const renderAllTabs = () => {
		return (
			<div className="navigation-tab bg-white shadow-nav-4dp">
				<ul>
					{TAB_FOR_ALL?.filter((item) => isShowArchiveTab || item.constant !== 'ARCHIVED')?.map(
						(item) => (
							<li
								key={item.name}
								className={`${selectedTab === item.name && 'active'}`}
								onClick={() => onClickDesignTab(item)}
							>
								{item.viewName}
							</li>
						)
					)}
				</ul>
			</div>
		);
	};

	const onSetViewSetting = async (selected) => {
		onClickTab(selected);
		let body = { ...getUserInfo()?.systemPreference };
		if (isFromNitexStudio) {
			body['NITEX_PAGE_TAB_VIEW'] = selected;
		} else {
			body['COLLECTION_PAGE_TAB_VIEW'] = selected;
		}
		await setSystemUserPreferences(body);
	};

	const isRequestFromSuggestedBuyer = () => {
		return selectedTab === 'SUGGESTED_FOR_BUYER';
	};

	return (
		<div className="top-header">
			{requestFrom === 'SUPPLIER_WISE_MATERIAL' ? (
				<div className="filter-container-top filter-container-top-v2 bg-white">
					<div className="filters">
						<div className="filter-toggle" onClick={() => toggleFilter()}>
							<img src={process.env.PUBLIC_URL + '/icons/filter24.svg'} alt="filter" />
							<span>Filter</span>
						</div>
						<span className="items-count semibold-14 gray_dark_02">
							{totalElements > 0 ? totalElements : 0} Items
						</span>
						<Chip />
					</div>
					<div className={`filter-actions collections-filter-actions ${addNewTitle}`}>
						<Search placeholder={searchBoxPlaceHolder} />
						{isShowAddButton && (
							<div className="add-new-design">
								<button
									className="button text size32 px-0"
									onClick={() => {
										if (callBack) {
											callBack();
										} else {
											setIsAddNew(true);
										}
									}}
								>
									<img src={process.env.PUBLIC_URL + '/icons/add-round.svg'} alt="add" />
									<span className="ml-1">{addNewTitle}</span>
								</button>
							</div>
						)}
					</div>
				</div>
			) : (
				<div>
					{!isFromNitexStudio && (
						<div className="collection-list">
							<div className="page-title-area">
								<h1 className="semibold-16">Collection</h1>
							</div>
							{renderAllTabs()}
						</div>
					)}

					<div className="filter-container-top filter-container-top-v2 bg-white d-block">
						<div className="d-flex align-items-center justify-content-between">
							<div className="filters">
								<div className="filter-toggle" onClick={() => toggleFilter()}>
									<img src={process.env.PUBLIC_URL + '/icons/filter24.svg'} alt="filter" />
									<span>Filter</span>
								</div>
								<span className="items-count semibold-14 gray_dark_02">
									{totalElements ? totalElements : filterResponse.totalElements}{' '}
									{totalElements > 0 || filterResponse.totalElements > 0 ? 'Items' : ''}
								</span>
								{viewType === 'DESIGN_TAB' && selectedTab === 'Sold' && (
									<div className="designers-techpack ml-3">
										<div className="custom-chekbox">
											<div className="form-group mt-1 mb-0">
												<input
													type="checkbox"
													id={'designers-techpack'}
													onChange={() =>
														setIsShowDesignersTechpack &&
														setIsShowDesignersTechpack(!isShowDesignersTechpack)
													}
													checked={isShowDesignersTechpack}
												/>
												<label htmlFor="designers-techpack" className="small-gap">
													<span>Designers Techpack</span>
												</label>
											</div>
										</div>
									</div>
								)}
							</div>
							<div className={`filter-actions collections-filter-actions ${addNewTitle}`}>
								{viewType === 'COLLECTION_TAB' && (
									<Search placeholder={searchBoxPlaceHolder} />
								)}
								{viewType === 'DESIGN_TAB' && (
									<AsyncSearch
										pathName={pathName}
										setIsShowFavouriteFolderPopup={setIsShowFavouriteFolderPopup}
									/>
								)}
								{!isRequestFromSuggestedBuyer() && (
									<React.Fragment>
										<div
											className={`view-tab ml-2 cursor-pointer ${
												viewType === 'COLLECTION_TAB' ? 'active' : ''
											} ${searchParams.get('designType') === 'SOLD' ? 'cursor-none' : ''}`}
											onClick={() => {
												dispatch(
													clearGlobalFilterWithSelectedFields([
														'dateRange',
														'fabric',
														'developmentLocations'
													])
												);
												onSetViewSetting('COLLECTION_TAB');
											}}
										>
											<img
												src={
													viewType === 'COLLECTION_TAB'
														? ICONS.COLLECTION_FILL_ICON
														: ICONS.COLLECTION_UNFILL_ICON
												}
												alt=""
											/>
										</div>

										<div
											className={`view-tab cursor-pointer ${
												viewType === 'DESIGN_TAB' ? 'active' : ''
											}`}
											onClick={() => {
												dispatch(clearGlobalFilterWithSelectedFields(['memberId']));
												onSetViewSetting('DESIGN_TAB');
											}}
										>
											<img
												src={
													viewType === 'DESIGN_TAB'
														? ICONS.DESIGN_FILL_ICON
														: ICONS.DESIGN_UNFILL_ICON
												}
												alt=""
											/>
										</div>

										<div
											className={`${viewType !== 'DESIGN_TAB' ? 'disabled-field' : ''}`}
										>
											<ListViewType
												type="COLLECTION_LIST"
												onSelectType={(selected) => onSetDefaultView(selected)}
											/>
										</div>

										<Permission
											allowedPermission={[PERMISSIONS.COSTING_SHOW_PRICE_IN_DESIGN]}
										>
											<div className="ml-2 pl-1">
												<Tooltip title={'Price show/hide'} placement="top" arrow>
													<img
														className="cursor-pointer"
														src={`${
															!isShowPrice
																? `${process.env.PUBLIC_URL}/icons/toggle-off.svg`
																: `${process.env.PUBLIC_URL}/icons/toggle-on.svg`
														}`}
														alt="Price Toggle"
														onClick={() => onPriceToggleClick(!isShowPrice)}
													/>
												</Tooltip>
											</div>
										</Permission>
									</React.Fragment>
								)}

								{showSorting && <Sort title={addNewTitle} />}
								{!isFromNitexStudio && !isRequestFromSuggestedBuyer() && (
									<div className="add-new-design">
										<button
											className="button text size32 px-0"
											onClick={() => {
												if (callBack) {
													callBack();
												} else {
													setIsAddNew(true);
												}
											}}
										>
											<img
												src={process.env.PUBLIC_URL + '/icons/add-round.svg'}
												alt="add"
											/>
											<span className="ml-1">Collection</span>
										</button>
									</div>
								)}
							</div>
						</div>
						<Chip />
					</div>
					{isAddNew && (
						<CollectionAddAndEdit
							type="ADD_NEW"
							title="Create new collection"
							onSubmiCollection={() => fetchCollectionList()}
							onClose={() => setIsAddNew(false)}
						/>
					)}
				</div>
			)}
		</div>
	);
};

export default FilterTopHeader;
